module.exports = __webpack_public_path__ + "img/view-star-animation-1.e23f7845.png";